export default __webpack_public_path__ + "static/media/dining2.a2239dd3.JPG";